import Vue from 'vue';
import {document, document_collection} from './documents.js'


Vue.component('asis-document', document);
Vue.component('asis-document-collection', document_collection);

